import './App.css';
import './index.css'
import AlfaBlock from './components/AlfaBlock/AlfaBlock';

function App() {
  return (
    <div>
      <AlfaBlock/>
    </div>
  );
}

export default App;
